<template>
  <div class="purchase-order-see-page">
    <div class="inquire-module-list" id="page-top">
      <a-row :gutter="24">
        <a-col :md="4" :sm="6" class="button-add-col" v-has="'purchase_order_add_button'">
          <div class="add-make-button" @click="btnAddPurchaseOrder">
            <a-button icon="plus" type="primary"></a-button>
            <span>新增采购订单</span>
          </div>
        </a-col>
        <a-col :md="5" :sm="6">
          <a-range-picker v-model="dateValue" format="YYYY-MM-DD" @change="changeData" />
        </a-col>
        <a-col :md="5" :sm="6">
          <a-tooltip>
            <template slot="title" v-if="formData.contactCustomerName">
              <span>{{ formData.contactCustomerName }}</span>
            </template>
            <a-input placeholder="往来单位" autoComplete="off" v-model="formData.contactCustomerName" :allowClear="true"
              @change="changeContactCustomer" @dblclick="btnReceiptModel" @pressEnter="btnReceiptModel"
              class="contact-customer-name-input">
              <!-- <a-tooltip slot="suffix" title="更多" @click="btnReceiptModel">
                <div style="height: 100%">
                  <img src="@/assets/image/gengduo.png" alt style="width: 12px;" />
                </div>
              </a-tooltip> -->
            </a-input>
          </a-tooltip>
        </a-col>
        <a-col :md="4" :sm="6">
          <a-select style="width: 100%;" placeholder="收货仓库" v-model="formData.inStorageName" @change="selectWarehouse">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in warehouseList" :key="index">
              <span>{{ item.storageName }}</span>
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="4" :sm="6">
          <a-select style="width: 100%;" v-model="formData.transactorName" placeholder="选择经办人" @change="selectAgent">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in agentList" :key="index">
              <span>{{ item.name }}</span>
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="4" :sm="6">
          <a-input placeholder="输入关键词查询" v-model="formData.keyWord" />
        </a-col>
        <a-col :md="3" :sm="6" class="button-ant-col">
          <a-button class="ant-btn-color border-arc" @click="btnInquire">查询</a-button>
          <a-button class="border-arc" @click="btnResetData">重置</a-button>
        </a-col>
      </a-row>
    </div>

    <div class="purchase-order-see-table page-table" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
        :scroll="{x:1000, y: (tableHeight) }" bordered>
        <!-- 序号 -->
        <template slot="serialNum" slot-scope="text, record, index">
          <span>{{  index+1 }}</span>
        </template>
        <!-- 编号 -->
        <template slot="code" slot-scope="text">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 摘要 -->
        <template slot="digest" slot-scope="text">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 备注 -->
        <template slot="remark" slot-scope="text">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <template slot="totalAmount" slot-scope="text">
          <span>{{  $comm.toDecimal2(text) }}</span>
        </template>
        <!-- 操作 -->
        <template slot="operation" slot-scope="text, record">
          <a-dropdown>
            <span class="dropdown-image"></span>
            <a-menu slot="overlay" style="width: 120px">
              <a-menu-item v-has="'purchase_order_inbound_order'" @click="generateOrder(text, record)"
                v-if="record.noInboundCount!=0">
                <a>生成采购入库单</a>
              </a-menu-item>
              <a-menu-item v-has="'purchase_order_look_order'" @click="btnLookDetails(text, record)">
                <a>查看</a>
              </a-menu-item>
              <a-menu-item v-has="'purchase_order_editor_order'" @click="btnGoSellOrderDetails(text, record)"
                v-if="record.inboundCount<=0">
                <a>编辑</a>
              </a-menu-item>
              <a-menu-item v-has="'purchase_order_delete_order'" @click="btnDeleteOrider(text, record)">
                <a>删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </a-table>
    </div>
    <div class="pagination-box">
      <a-pagination :total="ipagination.total" :page-size="ipagination.pageSize" :default-current="ipagination.current"
        :show-total="ipagination.showTotal" @showSizeChange="onShowSizeChange" @change="onChangeIpagination"
        show-size-changer show-quick-jumper />
    </div>
    <!-- 往来单位 -->
    <receipt-model ref="receipt" @onSelectModel="onSelectModel"></receipt-model>
    <!-- 删除弹窗 -->
    <delete-modal ref="deletemodal" @confirmDeletion="btnDeleteList"></delete-modal>
  </div>
</template>
<script>
import pick from "lodash.pick";
import receiptModel from "@/components/receiptModel.vue";
import deleteModal from "@/components/module/deleteModal.vue";
import { tableWidth } from "@/mixins/tableWidth";
import { methodlist } from "../method/methodlist";
export default {
  name: "purchaseOrderSee",
  mixins: [methodlist, tableWidth],
  components: {
    receiptModel,
    deleteModal,
  },
  data() {
    return {
      columns: [
        {
          title: "序号",
          align: "center",
          width: 80,
          dataIndex: "serialNum",
          ellipsis: true,
          scopedSlots: { customRender: "serialNum" },
        },
        {
          defaultWidth: 180,
          title: "单据编号",
          dataIndex: "code",
          ellipsis: true,
          scopedSlots: { customRender: "code" },
        },
        {
          defaultWidth: 120,
          title: "单据日期",
          ellipsis: true,
          dataIndex: "orderDate",
        },
        {
          defaultWidth: 120,
          title: "经办人",
          ellipsis: true,
          dataIndex: "transactorName",
        },
        {
          title: "金额",
          align: "right",
          dataIndex: "totalAmount",
          ellipsis: true,
          scopedSlots: { customRender: "totalAmount" },
        },
        {
          defaultWidth: 150,
          title: "往来单位",
          ellipsis: true,
          dataIndex: "contactCustomerName",
        },
        {
          defaultWidth: 120,
          title: "入库仓库",
          ellipsis: true,
          dataIndex: "inStorageName",
        },
        {
          title: "未入库数量",
          align: "right",
          ellipsis: true,
          dataIndex: "noInboundCount",
        },
        {
          title: "已入库数量",
          align: "right",
          ellipsis: true,
          dataIndex: "inboundCount",
        },
        {
          defaultWidth: 160,
          title: "摘要",
          dataIndex: "digest",
          ellipsis: true,
          scopedSlots: { customRender: "digest" },
        },
        {
          defaultWidth: 160,
          title: "备注",
          dataIndex: "remark",
          ellipsis: true,
          scopedSlots: { customRender: "remark" },
        },
        {
          width: 100,
          title: "操作",
          align: "center",
          dataIndex: "operation",
          ellipsis: true,
          scopedSlots: { customRender: "operation" },
        },
      ],
      urlList: {
        list: "/order/api/purchaseOrder/pageListPagePurchaseOrder",
        del: "/order/api/purchaseOrder/deletePurchaseOrder",
      },
    };
  },
  methods: {
    // 编辑详情
    btnGoSellOrderDetails(text, record) {
      this.$router.push({
        path: "/purchase/purchaseasmin/purchaseOrderEdit?id=" + record.id,
      });
    },
    // 生成销售出库单
    generateOrder(text, record) {
      this.$router.push({
        path:
          "/purchase/purchaseasmin/purchaseEnterWarehouse?id=" +
          record.id +
          "&type=2",
      });
    },
    // 查看详情
    btnLookDetails(text, record) {
      this.$router.push({
        path: "/purchase/purchaseasmin/purchaseOrderLook?id=" + record.id,
      });
    },
    btnAddPurchaseOrder() {
      this.$router.push({ path: "/purchase/purchaseasmin/purchaseOrder" });
    },
    // 删除按钮
    btnDeleteOrider(text, record) {
      this.$refs.deletemodal.show(record);
    },
  },
};
</script>

<style lang="scss">
.purchase-order-see-page {
  @import "../style/purchaselist.scss";
  .purchase-order-see-table {
    margin-top: 16px;
    .ant-table-fixed-left {
      .ant-table-body-inner {
        margin-right: -8px !important;
        margin-bottom: 0 !important;
      }
      .ant-table-body-outer {
        margin-bottom: 0 !important;
      }
    }
    .ant-table-fixed-right {
      .ant-table-body-outer {
        margin-bottom: 0 !important;
      }
    }
  }
  .ant-input-suffix {
    margin-right: 8px;
  }
}
</style>